import { Route, IndexRoute } from 'react-router'
import App from '../containers/App'
import React from '../helpers/react'
import ProblemContainer from '../containers/ProblemContainer.js';
import SingleSolution from '../containers/SingleSolution.js';
import {FakeSolution} from '../containers/FakeSolution.js';
import {mixins} from 'ereader-core/dist/utils.mixins.js';

export const default_routes = {
    'problem' : '/:isbn13/chapter/:chapter/problem/:problem',
    'chapter' : '/:isbn13/chapter/:chapter',
    'solution' : '/:isbn13/solution/:id',
    'base' : '/:isbn13/',
    'html' : '/test/html/'
};

function setRoutes(map){
    const _map = {};

    let routes = {...default_routes};

    for (let name in map) {
        _map[name] = map[name].replace(/(\(|\))/g,'');
    }

    routes = mixins.Options.setOptions(routes, map);

    return routes;
}

export function getRouter(routes={}){
    routes = setRoutes(routes);

    return {
        buildRoute : function(name, args){
            let route = routes[name];

            for (let key in args) {
                route = route.replace(`:${key}`, args[key]);
            }

            return route;
        },
        routes : (<Route path={routes.base} component={App}>
            <IndexRoute component={ProblemContainer} />
            <Route path={routes.problem} component={ProblemContainer} />
            <Route path={routes.chapter} component={ProblemContainer} />
            <Route path={routes.solution} component={SingleSolution} />

            <Route path={routes.html} component={FakeSolution} />
        </Route>)
    }
}



// WEBPACK FOOTER //
// ./src/helpers/routes.js